export let PusherEventName = /*#__PURE__*/function (PusherEventName) {
  PusherEventName["InvoiceXeroIntegrationStatusUpdated"] = "InvoiceXeroIntegrationStatusUpdated";
  PusherEventName["InvoiceQboIntegrationStatusUpdated"] = "InvoiceQboIntegrationStatusUpdated";
  PusherEventName["PayoutXeroIntegrationStatusUpdated"] = "PayoutXeroIntegrationStatusUpdated";
  PusherEventName["PayoutQboIntegrationStatusUpdated"] = "PayoutQboIntegrationStatusUpdated";
  PusherEventName["RelationshipCreatedFromScheduledDraft"] = "RelationshipCreatedFromScheduledDraft";
  return PusherEventName;
}({});